const SS_ADMIN = '/api/ss_admin';

export const END_POINTS = {
  signIn: `${SS_ADMIN}/sessions/sign_in`,
  signOut: `${SS_ADMIN}/sessions/sign_out`,
  me: `${SS_ADMIN}/me`,
  sites: `${SS_ADMIN}/sites`,
  sitesExport: `${SS_ADMIN}/sites/export`,
  siteBillingSettings: (siteId: string) => `${SS_ADMIN}/sites/${siteId}/billing_settings`,
  administrators: `${SS_ADMIN}/administrators`,
  administrator: (id: string) => `${SS_ADMIN}/administrators/${id}`,
  suspendAdministrator: (id: string) => `${SS_ADMIN}/administrators/${id}/suspend`,
  reactivateAdministrator: (id: string) => `${SS_ADMIN}/administrators/${id}/reactivate`,
  resendAdministratorInvite: (id: string) => `${SS_ADMIN}/administrators/${id}/resend_invite`,
  administratorMobile: (id: string) => `${SS_ADMIN}/administrators/${id}/mobile`,
  administratorMobilePreview: (id: string) => `${SS_ADMIN}/administrators/${id}/mobile/preview`,
  administratorMobileUnlock: (id: string) => `${SS_ADMIN}/administrators/${id}/mobile/unlock`,
  myMobilePin: `${SS_ADMIN}/me/mobile_pin`,
  passwordSetupCheck: `${SS_ADMIN}/password_setup/check`,
  passwordSetup: `${SS_ADMIN}/password_setup`,
  impersonations: `${SS_ADMIN}/impersonations`,
  impersonation: (id: string) => `${SS_ADMIN}/impersonations/${id}`,
  transactions: `${SS_ADMIN}/transactions`,
  transactionInvoice: (id: string) => `${SS_ADMIN}/transactions/${id}/invoice`,
  transactionReport: `${SS_ADMIN}/transactions/report`,
  settlements: `${SS_ADMIN}/disbursements/settlements`,
  payouts: `${SS_ADMIN}/disbursements/payouts`,
  payout: `${SS_ADMIN}/disbursements/payout`,
  settlementDay: `${SS_ADMIN}/disbursements/day`,
  recordPayouts: `${SS_ADMIN}/disbursements/batch`,
} as const;
